module.exports = __webpack_public_path__ + "img/chest.f16733b0.png";